<template>
  <div class="levelThree" v-if="loading">
    <div class="flex">
      <div class="title">性质：</div>
      <div class="flex typeDiv">
        <div v-for="item in typeList" :key="item.id" class="typeItemDiv cp">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="flex" v-if="typeList && typeList.length && typeList[0]">
      <div class="title">起点：</div>
      <div class="flex typeDiv">
        <div
          v-for="item in typeList[firstIndex].children"
          :key="item.id"
          class="typeItemDiv cp"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="title">方向：</div>
      <div class="flex typeDiv">
        <div
          v-for="item in typeList[firstIndex].children[secondIndex].children"
          :key="item.id"
          class="typeItemDiv cp"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/api/config";
export default {
  name: "findDirectionTemplate",
  props: {
    total: Number,
  },
  data() {
    return {
      loading: false,
      chooseTypeId: "",
      firstChooseTypeId: "",
      secondChooseTypeId: "",
      chooseCityId: "",
      firstIndex: 0,
      secondIndex: 0,
      typeList: [],
      cityList: [],
    };
  },
  methods: {
    getSubjectTreeList() {
      axios
        .get(`${process.env.BASE_URL}/subjectCourse/getSubjectTreeList?menuId=2`)
        .then((res) => {
          this.typeList = res.data;
          this.chooseTypeId = this.typeList[0].id;
          this.firstChooseTypeId = this.typeList[this.firstIndex].children[0].id;
          this.secondChooseTypeId = this.typeList[
            this.firstIndex
          ].children[0].children[0].id;
          this.loading = true;
        });
    },
    getDictionaryListCity() {
      axios
        .get(`${process.env.BASE_URL}/dictionary/getDictionaryListByParentId`, {
          params: { parentId: "1415494109434540034" },
        })
        .then((res) => {
          this.cityList = res.data;
        });
    },
  },
  mounted() {
    this.getSubjectTreeList();
    this.getDictionaryListCity();
  },
};
</script>
<style scoped>
.levelThree {
  background: #fff;
  width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 40px;
}
.typeDiv {
  width: calc(100% - 130px);
  flex-wrap: wrap;
}
.title {
  width: 50px;
}
.all {
  width: 80px;
}
.cp {
  cursor: pointer;
}
.typeItemDiv {
  padding: 0 16px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.active {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/findDirectionTemplate.vue